import { http } from '@pendo/http';

export function fetchAIFlags (subscriptionId = '_SID_', isSuperSettings = false) {
    let endpoint = `/api/s/${subscriptionId}/subscription/aiflag`;
    if (isSuperSettings) {
        endpoint = `/api/super/s/${subscriptionId}/subscription/aiflag`;
    }

    return http
        .get(endpoint, {
            bypassUnauthorizedLogout: true,
        })
        .then((res) => res.data);
}
